import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isReady: false,
};

export const analyticsReducer = createSlice({
    name: 'analytics',
    initialState,
    reducers: {
        createInstance: (state) => state,
        createInstanceSuccess: (state) => {
            state.isReady = true;
        },
        trackPageView: (state) => state,
        trackEvent: (state) => state,
    },
});

export const { createInstance, createInstanceSuccess, trackPageView, trackEvent } = analyticsReducer.actions;

export default analyticsReducer.reducer;
